/*
 * Copyright © 2026. Legalbird eine Marke der Legalbird GmbH
 */

import { Theme } from "@mui/material";

export const iconButtonLegalbirdStyle = {
  contained: (theme: Theme) => ({
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
    borderRadius: `${theme.shape.borderRadius}px`,
    padding: "1rem",
    width: "3rem",
    height: "3rem",
    "& .MuiSvgIcon-root": {
      fontSize: "1.25rem",
    },
    "&:hover": {
      backgroundColor: theme.palette.primary.dark,
      "@media (hover: none)": {
        backgroundColor: theme.palette.primary.main,
      },
    },
    "&:active": {
      boxShadow: "none",
    },
    "& .MuiTouchRipple-child": {
      borderRadius: theme.shape.borderRadius,
    },
    boxShadow: "none",
  }),
};
